export const errorConstants = {
    UPDATE: 'ERROR_UPDATE',
    RESET: 'ERROR_RESET'
};



// WEBPACK FOOTER //
// ./src/constants/errorDisplay.constants.js